
import PriceFormat from "../../../utils/priceFormat";
import { IPart } from "../../../models/Part";


export default function UnlistedTablePriceButton({ price, onPriceSelect, colour = "bg-primary-600", title = "" }: { price: number | null, onPriceSelect: any, colour?: string, title?: string }) {

  if (!price) {
    return null;
  }

  return (
    <button
      title={title}
      onClick={() => onPriceSelect(price)}
      className={`border text-white shadow rounded-md p-1 px-2 ${colour} hover:opacity-85 w-20 text-center`}
    >
      <span className="font-bold">{PriceFormat(price)}</span>
    </button>
  );

}